import React, { useEffect, useState } from 'react'
import { classStatus, getAllClasses } from '../../API/class'

function ManageClasses() {
    const [data, setData] = useState([])
    const [reload, setReload] = useState(false)

    useEffect(() => {
        getAllClasses()
            .then(data => setData(data))
    }, [reload])

    const handleApprove = (id) => {
        classStatus(id, "approved")
            .then(data => {
                if (data.modifiedCount === 1) {
                    setReload(!reload)
                }
            })
    }

    const handleReject = (id) => {
        classStatus(id, "denied")
            .then(data => {
                if (data.modifiedCount === 1) {
                    setReload(!reload)
                }
            })
    }

    return (
        <>
            <p className='text-center font-bold text-5xl tracking-tight pt-10 font-serif dark:text-white'>All Classes</p>
            <div className='max-w-[85%] mx-auto mt-8 pb-16'>
                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-center text-gray-700 uppercase bg-green-100 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="py-3">
                                    No.
                                </th>
                                <th scope="col" className="py-3 text-left">
                                    Image
                                </th>
                                <th scope="col" className="py-3 text-left">
                                    Class name
                                </th>
                                <th scope="col" className="py-3">
                                    Instructor
                                </th>
                                <th scope="col" className="py-3">
                                    Email
                                </th>
                                <th scope="col" className="py-3">
                                    Seat
                                </th>
                                <th scope="col" className="py-3">
                                    Price
                                </th>
                                <th scope="col" className="py-3">
                                    Status
                                </th>
                                <th scope="col" className="py-3">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((d, i) =>
                                    <tr key={d._id} className="bg-white text-center border-b dark:bg-gray-700 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <td className="p-4">
                                            <div className="flex ps-2 items-center">
                                                {i + 1}
                                            </div>
                                        </td>
                                        <th scope="row" className="py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            <img className='w-16' src={d.image} alt="" />
                                        </th>
                                        <th scope="row" className="py-4 font-medium text-gray-900 text-left whitespace-nowrap dark:text-white">
                                            {d.name}
                                        </th>
                                        <td className="py-4">
                                            {d.instructor.name}
                                        </td>
                                        <td className="py-4">
                                            {d.instructor.email}
                                        </td>
                                        <td className="py-4">
                                            {d.seat - d.enrolled}
                                        </td>
                                        <td className="px-4 py-4 text-center">
                                            {d.price}
                                        </td>
                                        <td className="py-4">
                                            {d.status}
                                        </td>
                                        <td className="py-4">

                                            <div className='flex items-center justify-center space-x-4'>
                                                <button className='disabled:cursor-not-allowed' onClick={() => handleApprove(d._id)} disabled={d.status === "approved" || d.status === "denied"}>
                                                    <img className='w-6' src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Flat_tick_icon.svg/768px-Flat_tick_icon.svg.png" alt="" />
                                                </button>
                                                <button className='disabled:cursor-not-allowed' onClick={() => handleReject(d._id)} disabled={d.status === "approved" || d.status === "denied"}>
                                                    <img className='w-6' src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Flat_cross_icon.svg/1024px-Flat_cross_icon.svg.png" alt="" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default ManageClasses